<div class="provider-section-grid" [formGroup]="formGroup">
  <div class="provider-section-header">
    <h5 class="section-title">
      {{ providerType === 'Tutor' ? 'Basic Information' : 'Personal Information' }}
    </h5>
  </div>
  <div class="provider-section-field">
    <div class="user-record-field-wrapper">
      <label for="firstName" class="field-label">First Name</label>
      <mat-form-field class="provider-fields">
        <input
          id="firstName"
          matInput
          type="text"
          placeholder="First Name"
          class="user-record-field-input"
          formControlName="firstName" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('firstName')" />
    </div>
  </div>
  <div class="provider-section-field">
    <div class="user-record-field-wrapper">
      <label for="lastName" class="field-label">Last Name</label>
      <mat-form-field class="provider-fields">
        <input
          id="lastName"
          matInput
          type="text"
          placeholder="Last Name"
          class="user-record-field-input"
          formControlName="lastName" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('lastName')" />
    </div>
  </div>
  <div class="provider-section-field">
    <div class="user-record-field-wrapper">
      <label for="email" class="field-label">Email Address</label>
      <mat-form-field class="provider-fields">
        <input
          id="email"
          matInput
          disabled
          type="text"
          placeholder="test@example.com"
          class="user-record-field-input"
          [value]="providerData.email" />
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field">
    <div class="user-record-field-wrapper">
      <label for="phone" class="field-label">Phone Number</label>
      <mat-form-field class="provider-fields">
        <input
          id="phone"
          matInput
          type="text"
          [mask]="'(000) 000-0000'"
          formControlName="phone"
          class="user-record-field-input"
          [dropSpecialCharacters]="false" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('phone')" />
    </div>
  </div>
  @if (!showReviewStatus) {
    <div class="provider-section-field">
      <div class="user-record-field-wrapper">
        <label for="secondaryPhone" class="field-label">Secondary Phone Number</label>
        <mat-form-field class="provider-fields">
          <input
            id="secondaryPhone"
            matInput
            type="text"
            [mask]="'(000) 000-0000'"
            formControlName="secondaryPhone"
            class="user-record-field-input"
            [dropSpecialCharacters]="false" />
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('secondaryPhone')" />
      </div>
    </div>
  }
  @if (providerType === 'Therapy') {
    <div class="provider-section-field">
      <div class="user-record-field-wrapper">
        <label for="birthDate" class="field-label">Date of Birth</label>
        <mat-form-field class="provider-fields">
          <input
            id="birthDate"
            matInput
            type="text"
            placeholder="MM/DD/YYYY"
            class="user-record-field-input"
            formControlName="birthDate"
            [mask]="'00/00/0000'" />
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('birthDate')" />
      </div>
    </div>
  }
  <div class="provider-section-field">
    <div class="user-record-field-wrapper">
      <label for="ssn" class="field-label">Social Security Number</label>
      <lib-ssn-field
          id="socialSecurityLast4TherapyPersonal"
          [control]="socialSecurityControl"
          [eyeButtonClass]="'eyeButtonClass'"
          [ariaErrorId]="
            formGroup.get('socialSecurityLast4')?.invalid && formGroup.get('socialSecurityLast4')?.touched
              ? 'socialSecurityLast4TherapyPersonal-error'
              : null
          ">
        </lib-ssn-field>
      <cfi-form-inline-error [control]="formGroup.get('socialSecurityLast4')" />
    </div>
  </div>
</div>
